import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  AgentStatusResponse,
  CreateTemplateVersionResponse,
  DownloadUrlResponse,
  GetTemplatesQueryParams,
  Template,
  TemplateRequest,
  UploadUrlResponse
} from '../models/templates';
import { ConfigurationService } from '../../services/configuration.service';
import { DriftConfiguration } from 'src/app/models/configuration.interface';
import { filter, Observable } from 'rxjs';

@Injectable()
export class WorkspaceTemplateService {
  private readonly templateUrl = '/workspace/template';
  private config!: DriftConfiguration;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly configurationService: ConfigurationService
  ) {
    //No unsub required
    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }

  private get apiUrl(): string {
    return `${this.config.driftApi}${this.templateUrl}`;
  }

  public getTemplates(params?: GetTemplatesQueryParams): Observable<Template[]> {
    let httpParams = new HttpParams();
    if (params?.show_latest) {
      httpParams = httpParams.set('show_latest', true);
    }
    return this.httpClient.get<Template[]>(this.apiUrl, { params: httpParams });
  }

  public createTemplate(data: TemplateRequest): Observable<CreateTemplateVersionResponse> {
    return this.httpClient.post<CreateTemplateVersionResponse>(this.apiUrl, data);
  }

  public createTemplateVersion(templateId: string, data: TemplateRequest): Observable<CreateTemplateVersionResponse> {
    const path = `${this.apiUrl}/${templateId}`;
    return this.httpClient.post<CreateTemplateVersionResponse>(path, data);
  }

  public getTemplateVersions(templateId: string): Observable<Template[]> {
    return this.httpClient.get<Template[]>(`${this.apiUrl}/${templateId}/versions`);
  }

  public generateUploadUrl(templateId: string, version: string, extension: string): Observable<UploadUrlResponse> {
    return this.httpClient.post<UploadUrlResponse>(`${this.apiUrl}/${templateId}/${version}/upload`, { extension });
  }
  public generateDownloadUrl(templateId: string, version: string): Observable<DownloadUrlResponse> {
    return this.httpClient.get<DownloadUrlResponse>(`${this.apiUrl}/${templateId}/${version}/download`);
  }

  public triggerTemplateAgent(templateId: string, version: string): Observable<{ message: string }> {
    return this.httpClient.post<{ message: string }>(`${this.apiUrl}/${templateId}/${version}/trigger-agent`, {});
  }

  public getAgentRunStatus(templateId: string, version: string): Observable<AgentStatusResponse> {
    return this.httpClient.get<AgentStatusResponse>(`${this.apiUrl}/${templateId}/${version}/agent-run-status`);
  }
}
